<template>
    <div>


        <section class="blk1 fz32">
            <div style="margin-left: 30px">သင်၏ OTP ကုဒ်ကို ထည့်ပါ။</div>
        </section>

        <div class="formbox blk3">
            <section>
              <input class="input-block" v-model="mobile" type="number" name="mobile" placeholder="Insert MPT phone Number" readonly>
            </section>
          <section class="otp-row">
            <input
              class="input-block otp-input"
              v-model="otp_code"
              type="number"
              name="otp_code"
              placeholder="Insert MPT OTP Number"
            />

            <button
              class="btn btn-red otp-btn"
              :disabled="!canSend"
              :class="{ disable: !canSend }"
              @click="getSendOtp"
            >
              {{ codeText }}
            </button>
          </section>
            <section>
                <div class="btn btn-block" @click="_otpAction">Confirm</div>
            </section>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Footer from './Footer'


export default {
    name: 'Otp',
    components: {Footer},
    data(){
        return{
          mobile: '',
          otp_code: '',
          codeText:'Resend',
          canSend: true,
          timer: null,
          countdown: 60,
          showLoad:false,
        }
    },
    computed: {
        ...mapState(['langMap','lang'])
    },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  created () {
    this.codeText = "Resend"
    if(this.$route.query.msisdn){
      this.mobile = this.$route.query.msisdn;
      this.getSendOtp();
    }
  },
  methods: {
    // Send OTP
    getSendOtp() {
      if (!this.canSend) return;
      if (!this.mobile) {
        this.$toast('မိုဘိုင်းနံပါတ်သည် ဗလာဖြစ်နေသည်။');
        return;
      }
      this.canSend = false;
      this.showLoad = true;
      Utils.$ajax({
        type: 'post',
        url: '/login/otp',
        data: {
          mobile: this.mobile
        }
      }).done(res => {
        this.showLoad = false;
        if (res.code === 0) {
          this.$toast('တစ်ကြိမ် အတည်ပြုကုဒ်ကို အောင်မြင်စွာ ပို့ပြီးပါပြီ။');
          this.startCountdown();
        } else {
          this.canSend = true;
          this.$toast('OTP ပေးပို့ခြင်း မအောင်မြင်ပါ။');
        }
      }).fail(() => {
        this.canSend = true;
        this.$toast('Network error');
      });
    },
    // Countdown
    startCountdown() {
      this.countdown = 60;
      this.codeText = `${this.countdown}s`;
      this.timer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          this.clearCountdown();
        } else {
          this.codeText = `${this.countdown}s`;
        }
      }, 1000);
    },
    clearCountdown() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
      this.codeText = 'Resend';
      this.canSend = true;
    },
    // Verify OTP
    _otpAction() {
      if (!this.otp_code) {
        this.$toast('ကျေးဇူးပြု၍ OTP ထည့်သွင်းပါ။');
        return;
      }

      Utils.$ajax({
        type: 'post',
        url: '/login/verify',
        data: {
          otp: this.otp_code,
          mobile: this.mobile
        },
      }).done(res => {
        if (res.code === 0) {
          localStorage.A_uuid = res.data.uuid;
          localStorage.A_token = res.data.token;
          this.$router.push('/');
        } else {
          this.$toast('မမှန်ကန်သော OTP');
        }
      });
    },
  },

}
</script>

<style lang="scss" scoped>
    .blk2{
        margin-top: rem(30);
        i{
            display: inline-block;
            width: 1.2em;
            line-height: 1.2em;
            text-align: center;
            border-radius: 50%;
            background-color: rgba(255,255,255,.3);
            vertical-align: middle;
            margin-right: .8em;
        }
    }
    .blk3{
        margin-top: rem(46);
        width: 90%;
        margin: 40px auto;
        section{
            margin-top: rem(34);
            &:first-child{
                margin-top: 0;
            }
        }
    }
    .otp-row {
      display: flex;
      align-items: center;
      gap: 10px;
    }

    .otp-input {
      flex: 1;
      min-width: 0;
    }

    .otp-btn {
      min-width: 120px;
      height: 50px;
      line-height: 50px;

      padding: 0 16px;
      white-space: nowrap;
    }
</style>



// WEBPACK FOOTER //
// src/components/otp.vue